// extracted by mini-css-extract-plugin
export default {"order":"order_order__EQllx","with-bg":"order_with-bg__+qrLW"};